/* ==========================================================================
    Remove Title tooltip popup from images
    Most people who want to hide the tooltip end up adding JavaScript to their sites so that they can keep the attribute in their image tags but prevent it from displaying on the front end.
    https://www.elegantthemes.com/blog/wordpress/image-title-attribute
   ========================================================================== */

jQuery(document).ready(function($) {
    $('img[title]').each(function() { $(this).removeAttr('title'); });
});